import React, { useEffect } from 'react';
import useRouter from '../../../utils/useRouter';
import useAction from '../../../utils/useAction';
import { selectMindItem } from '../../../reducers/mindItems.selectors';
import { useSelector } from 'react-redux';
import { fetchMindItem as fetchMindItemAction } from '../../../actions/mindItems.actions';
import { routes } from '../../../constants';
import MasterLayout from '../../../components/AppLayout/MasterLayout';
import { Box, Stack } from '@mui/material';
import { cardDimensionsMedia, palette, spaces } from '../../../assets/styles/themes/tokens';
import useScreenSize from '../../../utils/useScreenSize';
import PageHeader from '../../../components/PageHeader/PageHeader';
import { useTranslation } from 'react-i18next';
import CourseAttachmentsPageItem from './CourseAttachmentsPageItem';
import Breadcrumbs from '../../../components/Breadcrumbs';
import { IconName } from '../../../utils/getMuiIcon';
import Loader from '../Loader';

const CourseAttachmentsPage = () => {
  const { t } = useTranslation();
  const { router, match } = useRouter();
  const fetchCourseMindItem = useAction(fetchMindItemAction);
  const courseId = match.params.courseId;
  const mindItem = useSelector((state) => selectMindItem(state, courseId));

  const { isLargeScreen } = useScreenSize();
  
  useEffect(() => {
    fetchCourseMindItem(courseId);
  }, [courseId, fetchCourseMindItem]);

  useEffect(() => {
    if (!mindItem) return;

    const shouldNotRenderAttachments = 
      (mindItem.fileType === 'course' && mindItem.course.registrationStatus === 'none') ||
      mindItem.attachments.length === 0;

    if (shouldNotRenderAttachments) {
      router.replace(`/${routes.courseCover.root}/${courseId}`);
    }
  }, [mindItem, router, courseId]);

  return (
    <MasterLayout 
      customTopBarContent={
        <Breadcrumbs
          links={[
            {
              title: t('Search'),
              url: `/${routes.courseCatalog.root}`,
              iconName: 'searchDone' as IconName,
            },
            {
              title: t('Course overview'),
              url: `/${routes.courseCatalog.root}/${courseId}`,
              iconName: 'book' as IconName,
            },
            {
              title: mindItem?.title,
              url: `/${routes.coursePlayer.root.replace(':courseId', courseId)}`,
              iconName: 'docText' as IconName,
            },
            {
              title:  t('Attachments'),
              iconName: 'attachments' as IconName,
            },
          ]}
        />
      }
      forceNewNavigation
    >
      <Box
        sx={{
          paddingX: spaces.md,
          backgroundColor: palette.common.white,
          minHeight: '100%'
        }}
      >
        <Stack
          sx={{
            width: '100%',
            maxWidth: cardDimensionsMedia.desktop.maxWidth,
            marginX: 'auto',
            paddingX: isLargeScreen ? 0 : spaces.md,
          }}
          direction='column'
        >
          <PageHeader
            sx={{ color: palette.text.primary }}
            text={t('Attachments')}
          />
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: spaces.xs,
            }}
          >
            <Stack
              data-testid='attachments-list'
              direction='column'
              gap={spaces.xs}
            >
              {!mindItem ? <Loader /> : mindItem?.attachments.map((attachment) => (
                <CourseAttachmentsPageItem
                  key={attachment.id}
                  productId={mindItem.product}
                  attachment={attachment}
                />
              ))}
            </Stack>
          </Box>
        </Stack>
      </Box>
    </MasterLayout>
  );
};

export default CourseAttachmentsPage;
